{
  "maximum": "Maksimaalne",
  "minimum": "Minimaalne"
}
